// extracted by mini-css-extract-plugin
export default {"public-report":"oBktHxCchKo8OsY_wx1w"};